module.exports = __webpack_public_path__ + "static/media/motiv2@2x.c22b7403.png";